(() => {
  'use strict';
  if (window.NorelviCart?.add) return;
  const config = window.Norelvi || {root:'/',cart:'/cart',add:'/cart/add.js',change:'/cart/change.js'};
  const text = (key, fallback) => config.strings?.[key] || fallback;
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let busy = false, opener = null, stale = false, offerBlocked = false;
  const dialog = () => document.getElementById('NorelviCart');
  const sections = () => [...new Set([...document.querySelectorAll('[data-cart-content]')].map(el => el.dataset.sectionId))];
  function errors(message) { document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent=message;el.hidden=!message; }); }
  function setBusy(value) {
    busy=value;
    document.querySelectorAll('[data-cart-content]').forEach(el => {
      el.setAttribute('aria-busy',String(value));
      el.querySelectorAll('button,input,[data-cart-remove]').forEach(control => {
        if(value) { control.dataset.cartWasDisabled=String(control.disabled||false); if ('disabled' in control) control.disabled=true; control.setAttribute('aria-disabled','true'); }
        else if ('cartWasDisabled' in control.dataset) { if ('disabled' in control) control.disabled=control.dataset.cartWasDisabled==='true'; delete control.dataset.cartWasDisabled; control.removeAttribute('aria-disabled'); }
      });
    });
    document.querySelectorAll('[data-checkout]').forEach(b=>{if(stale || offerBlocked)b.disabled=true;});
  }
  async function request(url,body) {
    const response=await fetch(url,{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:body?'application/json':'text/html',...(body && !(body instanceof FormData)?{'Content-Type':'application/json'}:{})},...(body?{body:body instanceof FormData?body:JSON.stringify(body)}:{})});
    let data;try{data=await response.json();}catch{throw new Error(text('response_error', 'Die Antwort konnte nicht gelesen werden. Bitte prüfe deinen Warenkorb.'));}
    if(!data || typeof data!=='object')throw new Error(text('response_error', 'Die Antwort konnte nicht gelesen werden. Bitte prüfe deinen Warenkorb.'));
    if(!response.ok || data.status>=400) throw new Error(typeof data.description==='string'?data.description:text('mutation_error', 'Die Änderung konnte nicht gespeichert werden. Bitte prüfe die verfügbare Menge.'));
    return data;
  }
  function applySections(data) {
    let complete=true;
    for(const id of sections()) {
      const html=data?.[id];
      if(!html){complete=false;continue;}
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const next=parsed.querySelector('[data-cart-content]');
      const current=[...document.querySelectorAll('[data-cart-content]')].find(el=>el.dataset.sectionId===id);
      if(!next || !current){complete=false;continue;}
      current.replaceWith(next);
      const count=Number(next.dataset.itemCount||0);
      document.querySelectorAll('[data-cart-heading-count]').forEach(el=>{el.textContent=String(count);});
      document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=String(count);el.hidden=count===0;});
    }
    stale=!complete;
    return complete;
  }
  async function verifyOffers() {
    const cart=await request(root+'cart.js');
    const hasOffer=cart.items.some(item=>['a','b'].includes(item.properties?._norelvi_offer));
    offerBlocked=hasOffer && (!window.NorelviOfferDiscount || !window.NorelviOfferDiscount.validCart(cart,config.offerDiscount));
    if(offerBlocked)errors(text('offer_unavailable', 'Das Angebot ist gerade nicht verfügbar. Bitte entferne es oder versuche es später erneut.'));
    return !offerBlocked;
  }
  async function refresh() {
    const url=new URL(root+'cart',location.origin);url.searchParams.set('sections',sections().join(','));
    if(!applySections(await request(url.href))) throw new Error(text('refresh_error', 'Warenkorb konnte nicht aktualisiert werden. Bitte öffne die Warenkorbseite.'));
    await verifyOffers();
  }
  function open(trigger) {
    const d=dialog();if(!d || !d.showModal){location.assign(config.cart);return;}
    document.querySelectorAll('dialog[open]').forEach(other=>{if(other!==d)other.close();});
    if(!d.open){opener=trigger instanceof HTMLElement?trigger:document.activeElement;d.showModal();d.querySelector('[data-dialog-close]')?.focus();}
  }
  async function mutate(url,body,{show=false,trigger=null}={}) {
    if(busy)throw new Error(text('error_busy', 'Bitte warte, bis die aktuelle Änderung abgeschlossen ist.'));
    errors('');setBusy(true);
    const ids=sections();
    if(body instanceof FormData){body.set('sections',ids.join(','));body.set('sections_url',root+'cart');}
    else{body.sections=ids;body.sections_url=root+'cart';}
    let saved=false;
    try{
      if(url===config.change && window.NorelviOfferDiscount){
        const current=await request(root+'cart.js');
        const line=current.items.find(item=>item.key===body.id);
        const helper=window.NorelviOfferDiscount;
        if(line && (helper.isGrouped(line) || helper.isB(line))){
          let updates;
          try { updates=helper.quantityUpdates(current,body.id,body.quantity); }
          catch { throw new Error(text('group_quantity_error','Bitte wähle eine passende Angebotsmenge.').replaceAll('__QUANTITY__',String(helper.quantityStep(line)))); }
          url=root+'cart/update.js';
          body={updates,sections:ids,sections_url:root+'cart'};
        }
      }
      const data=await request(url,body);saved=true;
      if(!applySections(data.sections))await refresh();
      await verifyOffers();
      if(show)open(trigger);
      document.querySelectorAll('[data-cart-status]').forEach(el=>el.textContent=text('updated', 'Warenkorb aktualisiert.'));
      document.dispatchEvent(new CustomEvent('n:cart-updated'));
      return data;
    }catch(error){
      stale=true;
      try{await refresh();}catch{}
      if(saved){open(trigger);errors(text('saved_refresh_error', 'Die Änderung wurde gespeichert. Die Ansicht konnte nicht vollständig aktualisiert werden. Bitte öffne den Warenkorb.'));return {saved:true};}
      errors(error.message);throw error;
    }finally{setBusy(false);}
  }
  async function addOffer(body, offer, trigger) {
    if(busy)throw new Error(text('error_busy', 'Bitte warte, bis die aktuelle Änderung abgeschlossen ist.'));
    const percent=Number(offer.percent), configuredPercent=Number(config.offerDiscount?.percent);
    if(!window.NorelviOfferDiscount || !Number.isInteger(percent) || percent<0 || percent>50 || percent!==configuredPercent || (percent>0 && (offer.configured!==true || config.offerDiscount?.configured!==true))){const failure=new Error(text('offer_unavailable', 'Das Angebot ist gerade nicht verfügbar. Bitte versuche es später erneut.'));failure.cartMayHaveChanged=false;throw failure;}
    errors('');setBusy(true);
    try {
      const token=typeof crypto.randomUUID==='function'?crypto.randomUUID():Array.from(crypto.getRandomValues(new Uint32Array(4))).join('-');
      const cart=await window.NorelviOfferDiscount.purchase({request,root,config:config.offerDiscount,items:body.items,expected:offer.expected,token});
      offerBlocked=false;
      await refresh();
      if(offerBlocked)throw new Error(text('offer_unavailable', 'Das Angebot ist gerade nicht verfügbar.'));
      open(trigger);document.dispatchEvent(new CustomEvent('n:cart-updated'));
      return {items:cart.items,verified:true};
    } catch(failure) {
      offerBlocked=failure.cartMayHaveChanged!==false;
      try{await refresh();}catch{stale=true;}
      errors(failure.message);throw failure;
    } finally { setBusy(false); }
  }
  window.NorelviCart={add:(formData,submitter)=>mutate(config.add,formData,{show:true,trigger:submitter}),addOffer,refresh,open};
  document.addEventListener('click',async event=>{
    const openButton=event.target.closest('[data-cart-open]');
    if(openButton && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button===0){event.preventDefault();open(openButton);if(!busy){setBusy(true);try{await refresh();errors('');}catch(e){stale=true;errors(e.message);}finally{setBusy(false);}}return;}
    if(event.target.closest('[data-dialog-close]')){event.target.closest('dialog')?.close();return;}
    const remove=event.target.closest('[data-cart-remove]');const step=event.target.closest('[data-quantity-step]');
    if(!remove&&!step)return;
    if(event.ctrlKey||event.metaKey||event.shiftKey)return;
    event.preventDefault();if(busy)return;
    const row=event.target.closest('[data-line-key]');const input=row?.querySelector('[data-cart-quantity]');if(!row||!input)return;
    let quantity=0;if(step){quantity=Number(input.value)+Number(step.dataset.quantityStep)*Number(input.step||1);if(quantity<Number(input.min||1)||input.max&&quantity>Number(input.max))return;}
    try{await mutate(config.change,{id:row.dataset.lineKey,quantity});const replacement=[...document.querySelectorAll('[data-line-key]')].find(el=>el.dataset.lineKey===row.dataset.lineKey);(replacement?.querySelector('[data-cart-quantity]')||dialog()?.querySelector('[data-dialog-close]'))?.focus();}catch{}
  });
  document.addEventListener('change',async event=>{
    const input=event.target.closest('[data-cart-quantity]');if(!input||busy)return;
    if(!input.checkValidity()){input.reportValidity();return;}
    try{await mutate(config.change,{id:input.closest('[data-line-key]').dataset.lineKey,quantity:Number(input.value)});}catch{}
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;if(!form.matches('[data-cart-form]'))return;
    if(form.dataset.offerCheckoutVerified==='true'){delete form.dataset.offerCheckoutVerified;return;}
    if(busy||stale||offerBlocked){event.preventDefault();errors(text('check_cart', 'Bitte prüfe zuerst deinen Warenkorb.'));return;}
    if(event.submitter?.name!=='checkout')return;
    event.preventDefault();setBusy(true);
    try {if(await verifyOffers()){setBusy(false);form.dataset.offerCheckoutVerified='true';form.requestSubmit(event.submitter);}}catch{offerBlocked=true;errors(text('price_check_error', 'Der Angebotspreis konnte nicht geprüft werden. Bitte versuche es erneut.'));}finally{setBusy(false);}
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.n-menu[open]').forEach(el=>{el.open=false;el.querySelector('summary')?.focus();});});
  document.addEventListener('click',event=>{document.querySelectorAll('.n-menu[open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});});
  function bindDialogs(scope=document){scope.querySelectorAll('dialog').forEach(d=>{if(d.dataset.nBound)return;d.dataset.nBound='true';d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();});d.addEventListener('close',()=>{if(d.id==='NorelviCart'&&opener?.isConnected)opener.focus({preventScroll:true});});});}
  bindDialogs();document.addEventListener('shopify:section:load',()=>bindDialogs());
})();
